document.addEventListener('DOMContentLoaded', function(){

    // get video
    const video = document.querySelector('.about-us-theme-video');

    // observe for scroll on and play
    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if ( entry.isIntersecting && entry.intersectionRatio >= 0.5 ){
                video.play();
            }

        });
    }, 
    {
        threshold: 0.5
    });

    observer.observe(video);

    // pause on last frame
    video.addEventListener('ended', function(){
        // pause the video
        this.pause();  
    }, false);

});